import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 radius-7 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-15 mb-md-25 d-sm-flex align-items-center justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-0" }, "Logs"),
  /*#__PURE__*/_createElementVNode("div", { class: "card-buttons" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "javascript:void(0);",
      class: "card-btn mt-10 mt-sm-0 d-inline-block fw-medium text-decoration-none transition ps-10 pe-10 pt-5 pb-5 active"
    }, " Uploads em tempo real ")
  ])
], -1)
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Data "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Nome original "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Nome de conversão "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Duração "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Tamanho do arquivo ")
  ])
], -1)
const _hoisted_7 = { class: "shadow-none lh-1 text-black-emphasis" }
const _hoisted_8 = { class: "shadow-none lh-1 fw-bold text-black-emphasis" }
const _hoisted_9 = { class: "shadow-none lh-1 text-black-emphasis" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "badge text-bg-danger fs-13 radius-7"
}
const _hoisted_12 = { class: "shadow-none lh-1 text-black-emphasis" }
const _hoisted_13 = { class: "shadow-none lh-1 text-black-emphasis" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getRealtime, (item, key) => {
              return (_openBlock(), _createElementBlock("tr", { key: key }, [
                _createElementVNode("td", _hoisted_7, _toDisplayString(item.datetime), 1),
                _createElementVNode("td", _hoisted_8, _toDisplayString(item.data.originalName), 1),
                _createElementVNode("td", _hoisted_9, [
                  (item.data.file != null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(item.data.file), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_11, "Arquivo corrompido"))
                ]),
                _createElementVNode("td", _hoisted_12, _toDisplayString(item.data.duration), 1),
                _createElementVNode("td", _hoisted_13, _toDisplayString(item.data.size), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}